import React from 'react'
import RetourCourt from '../components/RetourCourt'

function Machine() {
  return (
    <div>
         <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Alex est la seule fille de sa promo de BTS « biomécanique automobile ». Pour son examen de fin d’études, elle a choisi de construire un moteur en chair artificielle. Une nuit, Chloé, qui partage sa chambre d’internat, découvre qu’Alex prend un plaisir singulier à travailler sur sa machine vivante…</p>
    </div>
    <div style={{textAlign:"center"}}> <RetourCourt /></div>
    </div>
    </div>
    </div>
  )
}

export default Machine